
import './App.css'
import PageManager from './G&CSCM/Core/PageManager';

function App() {

    return (
    <>
        <PageManager />
    </>
  )
}

export default App
